import React from 'react';
import { styled } from "@mui/material/styles";
import { Box } from '@mui/material';

const Root = styled(Box)(({ theme }) => ({
  backgroundColor: '#FAFAFA',
  padding: theme.spacing(2),
}));

type GroupSummariesCardItemBackgroundProps = React.ComponentPropsWithoutRef<'div'>;

/**
 * Styled Box component for use in GroupSummaries related cards containing groupings of titles/values
 * @param props passthrough props to the internal mui Box component
 * @constructor
 */
const GroupSummariesCardItemBackground = (props: GroupSummariesCardItemBackgroundProps) => {
  return <Root {...props} />
}

export { GroupSummariesCardItemBackground };
